import { HYDRATE_STATE } from "commons/src/reducers/indexActions";
import { getRangeStringFromId } from "commons/src/NuDateUtils";

import { ADD_ANALYSIS } from "./analysisActions";

export const analysis = (state = {}, action) => {
    switch (action.type) {
        case ADD_ANALYSIS:
            return {
                ...state,
                [getRangeStringFromId(action.rangeId)]: action.response
            };

        case HYDRATE_STATE:
            return { ...state, ...action.newState.analysis };

        default:
            return state;
    }
};
